import { Record, List } from "immutable"

type Input = {
  // eslint-disable-next-line flowtype/no-weak-types
  validators?: Array<Function>, // eslint-disable-line flowtype/no-weak-types
  required?: boolean,
}

const FieldValidatorRecord = Record({
  validators: List(),
  required: true,
})

export default class FieldValidator extends FieldValidatorRecord {
  constructor(input: Input = {}) {
    super(input)
  }

  // eslint-disable-next-line flowtype/no-weak-types
  add(fn: Function, error: string): FieldValidator {
    // eslint-disable-line flowtype/no-weak-types
    return this.set("validators", this.validators.push(FieldValidator.makeValidator(fn, error)))
  }

  /**
   * @param input what to check
   * @returns {null|string} null if OK, string (error msg) if bad
   */
  validate(input): ?string {
    if (!this.required && !input) {
      return null
    }

    return this.validators.reduce((acc, validator) => acc || validator(input), null)
  }

  validateToBool(input): boolean {
    return this.validators.every(validator => !validator(input))
  }

  /**
   * @param isValid validation function: true for valid, false for invalid
   * @param error error message key
   * @returns {function(T): ?string}
   */
  // eslint-disable-next-line flowtype/no-weak-types
  static makeValidator(isValid: Function, error: string): Function {
    // eslint-disable-line flowtype/no-weak-types
    return value => (isValid(value) ? null : error)
  }
}
